import { app } from '../../../bootstrap/core';
import accountNumberComponent from './accountNumber.component';
import {AccountNumberServiceProvider} from './accountNumber.service.provider.js';
import { BlzServiceProvider } from './blz.service.provider';

app.component('accountNumber', accountNumberComponent);
app.provider('accountNumberService', AccountNumberServiceProvider);
app.provider('blzService', BlzServiceProvider);



// WEBPACK FOOTER //
// ./src/app/common/ui/account-number/accountNumber.js